    function handleAddToCart(e) {
        const productId = e.target.getAttribute('data-variant-id');
        if (!productId) {
            return;
        }

        const button = e.target;
        if (button.disabled) return;
        button.disabled = true;

        const formData = new FormData();
        formData.append('id', productId);
        formData.append('quantity', '1');

        const sectionsToBundle = ["variant-added"];
        formData.append('sections', sectionsToBundle.join(','));
        formData.append('sections_url', `${Shopify.routes.root}variants/${productId}`);


        fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
        })
        .then(response => {
            if (!response.ok) {
            return response.json().then(errData => {
                throw new Error(errData.description || `HTTP ${response.status}`);
            });
            }
            return response.json();
        })
        .then(responseJson => {
            switch (window.themeVariables?.settings?.cartType) {
            case 'page':
                window.location.href = '/cart';
                break;
            case 'drawer':
                return handleDrawerCase(responseJson);
            case 'popover':
                handlePopoverCase(responseJson);
                break;
            default:
                triggerVariantAddEvent(responseJson, { sections: responseJson.sections });
            }
        })
        .catch(error => {
            alert(error.message || 'Failed to add product. Please try again.');
        })
        .finally(() => {
            button.disabled = false;
        });

        function handleDrawerCase(responseJson) {
            return fetch(`${Shopify.routes.root}cart.js`)
            .then(res => {
                if (!res.ok) throw new Error(`Failed to fetch cart: ${res.status}`);
                return res.json();
            })
            .then(cartContent => {
                cartContent.sections = responseJson.sections;
                
                triggerVariantAddEvent(responseJson, cartContent);
                document.dispatchEvent(new CustomEvent("cart:refresh"));
            });
        }

        function handlePopoverCase(responseJson) {
            const cartContent = { sections: responseJson.sections };
            
            triggerVariantAddEvent(responseJson, cartContent);
            document.dispatchEvent(new CustomEvent("cart:refresh"));
        }

        function triggerVariantAddEvent(responseJson, cartContent) {
            const items = responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson];
            
            document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items, cart: cartContent }
            }));
        }
    }